import { render, staticRenderFns } from "./AssignServiceDropdown.vue?vue&type=template&id=4d80b895&"
import script from "./AssignServiceDropdown.vue?vue&type=script&lang=js&"
export * from "./AssignServiceDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AssignServiceDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports